<div class="header-buttons-container" *ngIf="!isCheckout">
  <div class="content">
    <div class="search header-btn" tabindex="1" (click)="toggleSearch()">
      <svg *ngIf="!searchVisible" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill="#222" fill-rule="evenodd" d="M17.63 14.456l-4.652-4.631c.377-.818.593-1.724.593-2.682 0-3.544-2.884-6.429-6.428-6.429S.714 3.6.714 7.143c0 3.544 2.885 6.428 6.429 6.428.958 0 1.864-.216 2.682-.593l4.652 4.631c.417.418.966.627 1.515.627.548 0 1.097-.209 1.515-.627l.122-.123c.836-.835.836-2.195 0-3.03zM2.142 7.143c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm14.459 9.345l-.114.114c-.257.257-.675.257-.933 0l-4.474-4.475c.391-.304.742-.655 1.046-1.046l4.475 4.474c.257.258.257.676 0 .933z"/>
      </svg>
      <svg *ngIf="searchVisible" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fill-rule="evenodd">
          <g fill="#000">
            <g>
              <g>
                <g>
                  <g>
                    <path d="M17.412 3.588L16.412 2.588 10 9 3.561 2.561 2.561 3.561 9 10 2.561 16.439 3.561 17.439 10 11 16.439 17.439 17.439 16.439 11 10z" transform="translate(-230 -65) translate(0 35) translate(216 15) translate(14 15)"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <a [customRouterLink]="basketRoute" class="cart">
      <div class="header-btn" tabindex="1" >
        <div class="badge" *ngIf="badge$ | async as badge">
          <span> {{ badge }} </span>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <path fill="#222" fill-rule="evenodd" d="M16.429 13.571H7.658l-.47-1.428h9.24c1.182 0 2.143-.962 2.143-2.143V2.143H3.848L3.372.714H0v1.429h2.342L6.21 13.74c-1.116.39-1.923 1.441-1.923 2.688 0 1.575 1.281 2.857 2.857 2.857 1.576 0 2.857-1.282 2.857-2.857 0-.523-.151-1.007-.397-1.429h4.366c-.246.422-.398.906-.398 1.429 0 1.575 1.282 2.857 2.858 2.857 1.575 0 2.857-1.282 2.857-2.857 0-1.576-1.282-2.858-2.857-2.858zm.714-10V10c0 .394-.32.714-.714.714H6.712L4.324 3.571h12.819zM8.57 16.43c0 .787-.64 1.428-1.428 1.428-.788 0-1.429-.64-1.429-1.428 0-.788.641-1.429 1.429-1.429s1.428.64 1.428 1.429zm7.858 1.428c-.788 0-1.429-.64-1.429-1.428 0-.788.64-1.429 1.429-1.429.787 0 1.428.64 1.428 1.429 0 .787-.64 1.428-1.428 1.428z"/>
        </svg>
      </div>
      <kion-mini-basket class="mini-basket {{ showMiniBasketContainer ? 'show' : 'hide' }}" (mouseenter)="toggleMiniBasketView()" (mouseleave)="toggleMiniBasketView()"></kion-mini-basket>
    </a>
  </div>
</div>
